// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
  width: 145px;
}

.progress > svg {
  height: 10%;
  display: block;
}

.titolo,
ion-item p.titolo {
  font-size: 1rem;
}

.registrati,
ion-item p.registrati {
  font-size: 3.5rem;
  color: var(--color-primary);
}

.visible {
  visibility: visible;
}

.hidden {
  visibility: hidden;
}

.confermati {
  text-align: center;
}

.chiudi {
  margin-top: 10px;
}

.impedisciVerifica {
  color: white;
  background-color: var(--sfondo_rosso_accessibile);
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/verifica-presenza/verifica-presenza.page.scss"],"names":[],"mappings":"AACA;EACI,YAAA;AAAJ;;AAEA;EACI,WAAA;EACA,cAAA;AACJ;;AAEA;;EAEI,eAAA;AACJ;;AAEA;;EAEI,iBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ;;AACA;EACI,YAAA;EACA,iDAAA;EACA,iBAAA;AAEJ","sourcesContent":["\n.progress {\n    width: 145px;\n}\n.progress > svg {\n    height: 10%;\n    display: block;\n}\n\n.titolo,\nion-item p.titolo {\n    font-size: 1rem;\n}\n\n.registrati,\nion-item p.registrati {\n    font-size: 3.5rem;\n    color: var(--color-primary);\n  }\n\n.visible {\n    visibility: visible;\n}\n.hidden {\n    visibility: hidden;\n}\n\n.confermati {\n    text-align: center;\n}\n\n.chiudi {\n    margin-top: 10px;\n}\n\n.impedisciVerifica {\n    color: white;\n    background-color: var(--sfondo_rosso_accessibile);\n    font-size: 0.9rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
